import React from 'react';
import { Screen } from '../types';

const PaymentSuccessScreen = ({ navigateTo }) => {
  return (
    <div className="ilp-screen ilp-success-screen">
      <div className="ilp-success-icon">
        <div className="ilp-success-outer">
          <div className="ilp-success-inner">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4">
              <path d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        <div className="ilp-success-ping"></div>
      </div>

      <div className="ilp-success-text">
        <h1>Payment<br/>Successful!</h1>
        <p>Your transaction was completed successfully and your identity has been Aadhaar-verified.</p>
      </div>

      <div className="ilp-success-details">
        <div className="ilp-success-row">
          <span>Transaction ID</span>
          <strong>TXN_9928374821</strong>
        </div>
        <div className="ilp-success-row">
          <span>Status</span>
          <strong className="ilp-status-completed">Completed</strong>
        </div>
        <div className="ilp-success-row">
          <span>Identity Verification</span>
          <strong className="ilp-status-verified">Aadhaar Verified</strong>
        </div>
      </div>

      <div className="ilp-success-actions">
        <button className="ilp-primary-btn full" onClick={() => navigateTo(Screen.Success)}>
          <span>View My Permit</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessScreen;

